import { object } from 'valibot'

import { stringToNumber } from '@/libs/valibot'

export const truckModelParamsSchema = object({
  truckModelId: stringToNumber()
})
